// 历史记录 API 服务
import { HistoryItem } from '../store/appStore';

const API_BASE = '/api/history';

// 获取认证凭据
function getAuthHeader(): string {
  const username = localStorage.getItem('bankcard_auth_user') || '';
  const password = localStorage.getItem('bankcard_auth_pass') || '';
  return 'Basic ' + btoa(`${username}:${password}`);
}

// 设置认证凭据（登录时调用）
export function setAuthCredentials(username: string, password: string): void {
  localStorage.setItem('bankcard_auth_user', username);
  localStorage.setItem('bankcard_auth_pass', password);
}

// 清除认证凭据（登出时调用）
export function clearAuthCredentials(): void {
  localStorage.removeItem('bankcard_auth_user');
  localStorage.removeItem('bankcard_auth_pass');
}

// 获取历史记录
export async function fetchHistory(): Promise<HistoryItem[]> {
  try {
    const response = await fetch(API_BASE, {
      headers: {
        'Authorization': getAuthHeader(),
      },
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch history');
    }
    
    const data = await response.json();
    return data.history || [];
  } catch (error) {
    console.error('Failed to fetch history:', error);
    // 降级到本地存储
    return [];
  }
}

// 添加历史记录
export async function addHistoryItem(item: Omit<HistoryItem, 'id' | 'timestamp'>): Promise<HistoryItem | null> {
  try {
    const response = await fetch(API_BASE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthHeader(),
      },
      body: JSON.stringify(item),
    });
    
    if (!response.ok) {
      throw new Error('Failed to add history');
    }
    
    const data = await response.json();
    return data.item;
  } catch (error) {
    console.error('Failed to add history:', error);
    return null;
  }
}

// 删除单条历史记录
export async function deleteHistoryItem(id: string): Promise<boolean> {
  try {
    const response = await fetch(`${API_BASE}?id=${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': getAuthHeader(),
      },
    });
    
    return response.ok;
  } catch (error) {
    console.error('Failed to delete history:', error);
    return false;
  }
}

// 清空所有历史记录
export async function clearAllHistory(): Promise<boolean> {
  try {
    const response = await fetch(`${API_BASE}?id=all`, {
      method: 'DELETE',
      headers: {
        'Authorization': getAuthHeader(),
      },
    });
    
    return response.ok;
  } catch (error) {
    console.error('Failed to clear history:', error);
    return false;
  }
}
